import { AccountSystemTypes, AllowedPaymentMethods, ReservationStatus } from "../../../enums";
import { UserAppState } from "../../../enums/user-app-state";
import { translate } from "../../../i18n/translate";
import { isBalanceError } from "../../../utils/money";
const { PAST } = require("domuso-constants").reservation.ResidentStatus;

export const homepage = (props: any) => {
  const homepageActions = {
    rewardsButton: {
      visible: false,
      disabled: [],
    },
    paymentHistoryButton: {
      visible: true,
      disabled: [],
    },
    balanceDetailsButton: {
      visible: true,
      disabled: [],
    },
    maintenanceRequestsButton: {
      visible: true,
      disabled: [],
    },
    makeAPaymentButton: {
      visible: true,
      disabled: [],
    },
    submitMaintenanceRequestButton: {
      visible: true,
      disabled: [],
    },
    pointsBalanceDoubleStatusBadge: {
      visible: false,
      disabled: [],
    },
    reservationUnitSelectorDropdown: {
      visible: false,
      disabled: [],
    },
    bannerMessagesModal: {
      visible: false,
    },
    showAccountBalance: {
      visible: true,
    },
    showAccountBalanceDiscountOnRent: {
      visible: false,
    },
    showAutopayContent: {
      visible: true,
    },
    shouldDisableNonCertifiedMethods: false,
    isCustomer: true,
    hasError: false,
    isBlacklist: false,
    hasBalanceError: false,
    missingAllowedPayments: false,
    reservations: props?.reservations,
    isPendingSelfSignupUser: false,
    isPendingApplicantUser: false,
    isDoNotAcceptPayment: false,
    isAimPastResident: false,
    isRetrievingBalance: false,
  };

  const isCustomer = props?.isCustomer;
  const hasError = props?.hasError;
  const isBlacklist = props?.isBlacklist;
  const bannerMessages = props?.bannerMessages;

  const currentReservation = props?.currentReservation;
  const allReservations: any[] = props?.reservations;
  const currentUserAppState = props?.currentUserAppState;

  homepageActions.isCustomer = isCustomer;
  homepageActions.hasError = hasError;
  homepageActions.isBlacklist = isBlacklist;

  homepageActions.hasBalanceError = isBalanceError(
    currentReservation?.accounting_details?.balanceDue
  );
  homepageActions.isRetrievingBalance = currentReservation?.accounting_details?.queued ?? false;
  homepageActions.missingAllowedPayments =
    currentReservation?.accounting_details?.is_integrated && !currentReservation?.allowed_payments;

  let accountSystemType = currentReservation?.account_system_type;
  let currentPropertyProfile = currentReservation?.property_profile;
  const reservationStatus = currentReservation?.status;
  const reservationType = currentReservation?.reservation_type;
  const residentStatus = currentReservation?.account_system_resident_status;
  const balanceDue = currentReservation?.accounting_details?.balanceDue;

  homepageActions.isPendingSelfSignupUser =
    reservationType === ReservationStatus.INVITE_SELF &&
    reservationStatus === ReservationStatus.NEW;

  homepageActions.isPendingApplicantUser =
    reservationType === ReservationStatus.SELF &&
    (reservationStatus === ReservationStatus.NEW ||
      reservationStatus === ReservationStatus.PENDING);

  homepageActions.isAimPastResident =
    accountSystemType == AccountSystemTypes.AIM && residentStatus === PAST;

  //When account_system_allowed_payment is null backend will get allowedPayments from PMS need to check both
  homepageActions.isDoNotAcceptPayment =
    currentReservation?.account_system_allowed_payment ===
      AllowedPaymentMethods.DO_NOT_ACCEPT_PAYMENT ||
    currentReservation?.accounting_details?.allowedPayments ===
      AllowedPaymentMethods.DO_NOT_ACCEPT_PAYMENT ||
    //Do not use logical NOT(!) we don't want to return true when accounting_details is undefined
    currentReservation?.accounting_details?.makePaymentEnabled === false;

  const isCashOnlyResident =
    currentReservation?.account_system_allowed_payment === AllowedPaymentMethods.CASH_EQUIVALENT ||
    currentReservation?.accounting_details?.allowedPayments ===
      AllowedPaymentMethods.CASH_EQUIVALENT;

  const transactionsFromPMS =
    accountSystemType === AccountSystemTypes.YARDI ||
    accountSystemType === AccountSystemTypes.AIM ||
    accountSystemType === AccountSystemTypes.REALPAGE ||
    accountSystemType === AccountSystemTypes.RESMAN;
  const canViewAccountHistory =
    currentPropertyProfile?.allow_account_history && transactionsFromPMS;

  /*
    When user is blacklisted disable Make A Payment
    and Request Service Button
  */
  if (allReservations && allReservations?.length && isBlacklist) {
    homepageActions.makeAPaymentButton.disabled.push(
      translate("homepage.reservationCard.blacklistedHomePageTitle")
    );
    homepageActions.submitMaintenanceRequestButton.disabled.push(
      translate("homepage.reservationCard.blacklistedHomePageTitle")
    );
  }

  /*
    When service requests are not allowed hide Request Service
    and Maintenance Requests Button
  */
  if (!currentReservation?.allowServiceRequests) {
    homepageActions.submitMaintenanceRequestButton.visible = false;
    homepageActions.maintenanceRequestsButton.visible = false;
  }

  /*
    Disable Make a Payment button, hide autopay and show OnScreenAlert when:
     - account_system_allowed_payment === "DO_NOT_ACCEPT_PAYMENT (DTECH-32, DTECH-465)
     - or accounting_details.makePaymentEnabled is != true
  */
  if (homepageActions?.isDoNotAcceptPayment) {
    homepageActions.makeAPaymentButton.disabled.push("Payments not allowed");
    homepageActions.showAutopayContent.visible = false;
  }

  /*
  Hide autopay when currentReservation?.accounting_details?.allowedPayments === CASH_EQUIVALENT
  */
  if (isCashOnlyResident) {
    homepageActions.showAutopayContent.visible = false;
  }

  /*
    Show Maintenance Request and Make A Payment Button
    when reservations are available
  */
  if (!allReservations || !allReservations?.length) {
    homepageActions.reservationUnitSelectorDropdown.visible = false;
    homepageActions.submitMaintenanceRequestButton.visible = false;
    homepageActions.makeAPaymentButton.visible = false;
  }

  /*
    show reservation unit selector only when
    reservation length is greater that 1
  */
  if (allReservations && allReservations?.length && allReservations?.length > 1) {
    homepageActions.reservationUnitSelectorDropdown.visible = true;
  }
  /*
    Show account history only if
    currentPropertyProfile.allow_account_history == true  &&
    (accountSystemType == "YARDI" || accountSystemType == "AIM" || accountSystemType == "RESMAN"
    hide otherwise
  */
  if (!canViewAccountHistory) {
    homepageActions.balanceDetailsButton.visible = false;
  }

  /*
    Show banner Message Modal only
    when reservations and bannerMessages are available
  */
  if (allReservations && allReservations?.length && bannerMessages) {
    homepageActions.bannerMessagesModal.visible = true;
  }

  /*
    Show OnScreenAlert when balance due is not available.
    This happens when there is an error retreiving account details or the PMS times out
    API will return balanceDue = "temporarily unavailable"
  */
  if (allReservations && allReservations?.length && homepageActions?.hasBalanceError) {
    homepageActions.makeAPaymentButton.disabled.push("Payment not allowed: Balance not available");
    // if they are just queued for balance, we should let them view and submit maintenance requests
    if (!homepageActions?.isRetrievingBalance) {
      homepageActions.submitMaintenanceRequestButton.disabled.push(
        "Submit Maintenance request not allowed: Balance not available"
      );
      homepageActions.maintenanceRequestsButton.disabled.push(
        "View maintance request history not allowed: Balance not available"
      );
      homepageActions.balanceDetailsButton.disabled.push(
        "View balance details not allowed: Balance not available"
      );
    }
  }

  /*
    When there’s an unintegrated property:
    - don’t show the Account Balance, View Balance Details, or View Maintenance Requests Buttons (DTECH-42)
    When is a self signup user:
    - Ignore check it will be handled by its own business block (DTECH-45)
    When is applicant flow user:
    - Ignore check it will be handled by its own business block (DTECH-45)
  */
  if (
    !currentReservation?.accounting_details?.is_integrated &&
    !homepageActions?.isPendingSelfSignupUser &&
    !homepageActions.isPendingApplicantUser
  ) {
    homepageActions.balanceDetailsButton.visible = false;
    homepageActions.maintenanceRequestsButton.visible = false;
    homepageActions.showAccountBalance.visible = false;
  }

  /*
    Show pending property verification OnScreenAlert when:
    - (Self Signup Flow) reservation_type=INVITE_SELF and reservationStatus = NEW (DTECH-45)
    - (Applicant flow) reservation_type=SELF and reservationStatus = NEW or reservationStatus = PENDING  (DTECH-45)
  */
  if (homepageActions?.isPendingSelfSignupUser || homepageActions?.isPendingApplicantUser) {
    homepageActions.showAutopayContent.visible = false;
    homepageActions.showAccountBalance.visible = false;
    homepageActions.submitMaintenanceRequestButton.disabled.push(
      "Submit Maintenance request not allowed: resident pending approval"
    );
    homepageActions.balanceDetailsButton.disabled.push(
      "View balance details not allowed: Resident pending approval"
    );
    homepageActions.maintenanceRequestsButton.disabled.push(
      "View maintance request history not allowed: resident pending approval"
    );
  }

  if (homepageActions.isAimPastResident) {
    homepageActions.balanceDetailsButton.disabled.push(
      "View balance details not allowed: Aim resident is Past"
    );
  }

  if (currentUserAppState == UserAppState.PAYMENT_ONLY) {
    homepageActions.pointsBalanceDoubleStatusBadge.visible = false;
    homepageActions.rewardsButton.visible = false;
    homepageActions.showAccountBalanceDiscountOnRent.visible = false;
  } else if (
    currentUserAppState == UserAppState.UNIFIED ||
    currentUserAppState == UserAppState.REWARD_ONLY
  ) {
    homepageActions.pointsBalanceDoubleStatusBadge.visible = true;
    homepageActions.rewardsButton.visible = true;
    homepageActions.showAccountBalanceDiscountOnRent.visible = true;
  }

  if (!props?.rewardsData?.rewardAmountPendingUse) {
    homepageActions.showAccountBalanceDiscountOnRent.visible = false;
  }

  return homepageActions;
};
